// Types
import { ResponseGpoSearch } from "interfaces/osaSearch";
import { UserInfo } from "interfaces/userInfo";

export const NUMBER_ELEMENTS_SUGGESTION = 15;
export const NUMBER_ELEMENTS_PER_PAGE = 15;

export const defaultResultsQuery: ResponseGpoSearch = {
	totalRows: 0,
	currentRows: 0,
	results: []
};
export const defaultUserInfo: UserInfo = {
	isLogged: false,
	userName: "",
	linkRegistrazione: "",
	numelchart: 0,
	hrefchart: "",
	htmlHeader: "",
	htmlFooter: "",
	stripeActive: []
}
